export const screenSizes = [
  'xs',
  'sm',
  'md',
  'lg',
  'xl',
  'xxl'
];